/* ================================================================================
   Ancona Pass 16 — deluxe layer (ancona-deluxe.js)
   Private-Client Inquiry: bridges the existing browser-local Saved Pieces and
   Product Compare lists into the NATIVE Contact Ancona journey for higher-ticket
   shoppers. No new list, no server storage, no external service, no PII, no
   auto-submit. Public product context only (handle/url/title/variant title),
   sessionStorage, 30-minute expiry, capped at 8. Feature flag: this <script>
   tag's data-ancona-deluxe attribute (token: inquiry). Absent attr → all;
   empty string → none. Reuses the frozen Pass 12/13 layers only through their
   public CustomEvents and shared storage keys — those files are not modified.
   ================================================================================ */
(function () {
  'use strict';
  if (window.__anconaDeluxe) return;
  window.__anconaDeluxe = true;

  var script = document.currentScript;
  var featAttr = script ? script.getAttribute('data-ancona-deluxe') : null;
  var FEATURES = (featAttr == null ? 'inquiry' : featAttr).split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  function on(f) { return FEATURES.indexOf(f) !== -1; }

  function track(ev, payload) {
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') window.dataLayer.push(Object.assign({ event: 'ancona:' + ev }, payload || {}));
      document.dispatchEvent(new CustomEvent('ancona:' + ev, { detail: payload || {} }));
    } catch (e) { /* analytics must never break shopping */ }
  }

  var LS = null, SS = null;
  try { LS = window.localStorage; LS.setItem('ancona:v1:t', '1'); LS.removeItem('ancona:v1:t'); } catch (e) { LS = null; }
  try { SS = window.sessionStorage; SS.setItem('ancona:v1:t', '1'); SS.removeItem('ancona:v1:t'); } catch (e) { SS = null; }

  function sGet(store, key) {
    if (!store) return null;
    try {
      var v = store.getItem(key);
      return v ? JSON.parse(v) : null;
    } catch (e) {
      try { store.removeItem(key); } catch (_) {}
      return null;
    }
  }
  function sSet(store, key, val) {
    if (!store) return false;
    try { store.setItem(key, JSON.stringify(val)); return true; } catch (e) { return false; }
  }

  /* Shared polite live region for status announcements (WCAG 4.1.3). */
  var liveRegion = null;
  function announce(msg) {
    try {
      if (!liveRegion) {
        liveRegion = document.createElement('div');
        liveRegion.className = 'ancona-visually-hidden';
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('role', 'status');
        document.body.appendChild(liveRegion);
      }
      liveRegion.textContent = '';
      window.setTimeout(function () { liveRegion.textContent = msg; }, 30);
    } catch (e) {}
  }

  var INQ_KEY = 'ancona:v1:inquiry-context';
  var SAVED_KEY = 'ancona:v1:saved';
  var COMPARE_KEY = 'ancona:v1:compare';
  var MAX = 8;
  var TTL = 1800000; /* 30 minutes */
  /* Ancona Pass 25: locale-root-safe contact path (I1) — built from Shopify.routes.root
     (always ends with '/') exactly like ancona-cart-save.js does, so the inquiry handoff
     and the contact-page check survive /{locale}/ roots. Remove this block and restore
     var CONTACT_URL = '/pages/contact'; to revert. */
  var CONTACT_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CONTACT_URL = CONTACT_ROOT.replace(/\/$/, '') + '/pages/contact';

  function listOf(key) {
    var v = sGet(LS, key);
    return Array.isArray(v) ? v.filter(function (x) { return x && typeof x.h === 'string' && typeof x.u === 'string'; }) : [];
  }

  /* Write the public shortlist context and hand off to the native Contact page.
     Degrades gracefully: if sessionStorage is unavailable the shopper still
     reaches Contact, just without prefilled product context. */
  function startInquiry(source, rawItems) {
    var items = rawItems.slice(0, MAX).map(function (x) {
      var o = { h: x.h, u: x.u, t: (x.t || x.h).slice(0, 90) };
      if (x.vt) o.vt = String(x.vt).slice(0, 60);
      return o;
    });
    if (!items.length) return false;
    sSet(SS, INQ_KEY, { items: items, source: source, ts: Date.now() });
    track('inquiry_start', { source: source, count: items.length });
    window.location.href = CONTACT_URL;
    return true;
  }

  /* ---- Inquiry entry point injected into the (frozen) Saved / Compare dialogs -- */
  function injectDialogInquiry(source) {
    var dlg = document.querySelector('.ancona-dlg[role="dialog"]');
    if (!dlg) return;
    var actions = dlg.querySelector('.ancona-dlg__actions');
    if (!actions || actions.querySelector('.ancona-inquiry-btn')) return; /* idempotent */
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ancona-inquiry-btn';
    btn.textContent = 'Ask Ancona about these pieces';
    btn.addEventListener('click', function () {
      var list = listOf(source === 'compare' ? COMPARE_KEY : SAVED_KEY);
      if (!list.length) return;
      startInquiry(source, list);
    });
    actions.insertBefore(btn, actions.firstChild);
  }

  function initDialogHooks() {
    /* Header hub dialogs announce themselves via Pass 13 CustomEvents; defer one
       tick so the (synchronously built) dialog is in the DOM before we inject. */
    document.addEventListener('ancona:saved_open', function () { window.setTimeout(function () { injectDialogInquiry('saved'); }, 0); });
    document.addEventListener('ancona:compare_open', function () { window.setTimeout(function () { injectDialogInquiry('compare'); }, 0); });
    /* The PDP "Your saved pieces (n)" trigger (Pass 12) opens the saved dialog
       without an event — hook its click directly (targeted, no observer). */
    var savedTrigger = document.getElementById('AnconaSavedOpen');
    if (savedTrigger) savedTrigger.addEventListener('click', function () { window.setTimeout(function () { injectDialogInquiry('saved'); }, 0); });
  }

  /* ---- PDP "Ask about this piece" (single product, + selected variant) -------- */
  function selectedVariantTitle() {
    try {
      var vs = document.querySelector('variant-selects, variant-radios');
      if (!vs) return '';
      var parts = [];
      Array.prototype.forEach.call(vs.querySelectorAll('fieldset'), function (fs) {
        var checked = fs.querySelector('input:checked');
        if (checked && checked.value) parts.push(checked.value);
      });
      Array.prototype.forEach.call(vs.querySelectorAll('select'), function (sel) {
        if (sel.value) parts.push(sel.value);
      });
      var vt = parts.join(' / ').trim();
      if (!vt || /default title/i.test(vt)) return '';
      return vt;
    } catch (e) { return ''; }
  }

  function initProductInquiry() {
    var wrap = document.querySelector('.ancona-inquiry');
    var btn = document.getElementById('AnconaInquiryBtn');
    if (!btn) return;
    /* Ships hidden; revealed once JS runs (feature on). Click always reaches
       Contact — with context when storage works, neutral otherwise. Re-revealing
       is safe on a theme-editor section reload; wiring guards against a duplicate
       listener so this is idempotent. */
    if (wrap) wrap.hidden = false;
    if (btn.dataset.anconaWired) return;
    btn.dataset.anconaWired = '1';
    btn.addEventListener('click', function () {
      var d = btn.dataset;
      var item = { h: d.handle, u: d.url, t: d.title || d.handle };
      var vt = selectedVariantTitle();
      if (vt) item.vt = vt;
      startInquiry('product', [item]);
    });
  }

  /* ---- Contact page: accessible summary + editable prefilled message ---------- */
  function buildMessage(items) {
    var lines = items.map(function (it) {
      return '• ' + it.t + (it.vt ? ' (' + it.vt + ')' : '') + ' — ' + window.location.origin + it.u;
    });
    return 'Hello Ancona,\n\nI’d like to ask about these pieces:\n' + lines.join('\n') + '\n\nMy question: ';
  }

  function initContactPage() {
    /* Ancona Pass 25: locale-root-safe pathname check (I1) — matches the root-aware
       CONTACT_URL above. Restore indexOf('/pages/contact') to revert. */
    if (window.location.pathname.indexOf(CONTACT_URL) === -1) return;
    if (!SS) return;
    var ctx = sGet(SS, INQ_KEY);
    if (!ctx || !Array.isArray(ctx.items) || !ctx.items.length) return;
    if (Date.now() - (ctx.ts || 0) > TTL) { try { SS.removeItem(INQ_KEY); } catch (e) {} return; }
    var form = document.querySelector('form[action*="/contact"]');
    if (!form || document.querySelector('.ancona-inqbox')) return;

    var box = document.createElement('section');
    box.className = 'ancona-inqbox';
    box.setAttribute('aria-label', 'Pieces you are asking about');
    var head = document.createElement('h2');
    head.className = 'ancona-inqbox__head';
    head.textContent = 'Asking about these pieces';
    var note = document.createElement('p');
    note.className = 'ancona-inqbox__note';
    note.textContent = 'From your browser. Edit the message below before sending — nothing is sent automatically.';
    var ul = document.createElement('ul');
    ul.className = 'ancona-inqbox__list';
    ul.setAttribute('role', 'list');
    ctx.items.forEach(function (it) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = it.u;
      a.textContent = it.t + (it.vt ? ' — ' + it.vt : '');
      li.appendChild(a);
      ul.appendChild(li);
    });
    var clear = document.createElement('button');
    clear.type = 'button';
    clear.className = 'ancona-inqbox__clear';
    clear.textContent = 'Clear these pieces';
    box.appendChild(head); box.appendChild(note); box.appendChild(ul); box.appendChild(clear);
    form.parentNode.insertBefore(box, form);

    var ta = form.querySelector('textarea[name="contact[Comment]"]') || form.querySelector('textarea[name="contact[body]"]') || form.querySelector('textarea');
    var prefill = buildMessage(ctx.items);
    /* Never clobber text the shopper already typed. */
    if (ta && !ta.value.trim()) ta.value = prefill;
    track('inquiry_context', { count: ctx.items.length, source: ctx.source || '' });

    clear.addEventListener('click', function () {
      try { SS.removeItem(INQ_KEY); } catch (e) {}
      if (ta && ta.value === prefill) ta.value = '';
      /* Move focus before removing the box (the clear button lives inside it) so
         keyboard/AT focus never falls to <body>, and announce the change. */
      if (ta && ta.focus) ta.focus();
      box.remove();
      announce('Pieces cleared from your message.');
    });
  }

  function boot() {
    if (!on('inquiry')) return;
    /* Each init is isolated: a throw in one must not break the others or the page. */
    try { initDialogHooks(); } catch (e) {}
    try { initProductInquiry(); } catch (e) {}
    try { initContactPage(); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Theme-editor lifecycle: when the merchant reloads the product section, the
     re-rendered inquiry button ships hidden again — re-reveal it (idempotent). */
  document.addEventListener('shopify:section:load', function () {
    if (!on('inquiry')) return;
    try { initProductInquiry(); } catch (e) {}
  });
})();
